(function(){
  const root = document.querySelector('[data-ap-quiz]');
  if(!root) return;

  const steps = root.querySelectorAll('[data-ap-step]');
  const bar = root.querySelector('[data-ap-progress]');
  const total = steps.length;
  const answers = {};
  let current = 1;

  function show(n){
    if(n < 1 || n > total) return;
    steps.forEach(s => s.classList.remove('ap-step--active'));
    const next = root.querySelector('[data-ap-step="' + n + '"]');
    if(!next) return;
    next.classList.add('ap-step--active');
    current = n;
    bar.style.width = Math.round((n/total)*100) + '%';
    window.scrollTo({top:0, behavior:'smooth'});
  }

  root.addEventListener('click', function(e){
    const next = e.target.closest('[data-ap-next]');
    if(next){ show(current + 1); return; }

    const skip = e.target.closest('[data-ap-skip]');
    if(skip){ show(total); return; }

    const opt = e.target.closest('[data-ap-answer]');
    if(opt){
      answers[opt.dataset.apAnswer] = opt.dataset.val;
      try { sessionStorage.setItem('ap_answers', JSON.stringify(answers)); } catch(_){}
      show(current + 1);
    }
  });
})();
